var map = {
	"./Accessory.js": 36509,
	"./Bag.js": 79601,
	"./Book.js": 5414,
	"./Clothing.js": 59419,
	"./DeviceCase.js": 7641,
	"./Embroidery.js": 1491,
	"./HomeDecor.js": 39171,
	"./Material.js": 33106,
	"./Scarf.js": 41274,
	"./Stationery.js": 31465,
	"./WallArt.js": 6202,
	"create/ProductCategories/Accessory.js": 36509,
	"create/ProductCategories/Bag.js": 79601,
	"create/ProductCategories/Book.js": 5414,
	"create/ProductCategories/Clothing.js": 59419,
	"create/ProductCategories/DeviceCase.js": 7641,
	"create/ProductCategories/Embroidery.js": 1491,
	"create/ProductCategories/HomeDecor.js": 39171,
	"create/ProductCategories/Material.js": 33106,
	"create/ProductCategories/Scarf.js": 41274,
	"create/ProductCategories/Stationery.js": 31465,
	"create/ProductCategories/WallArt.js": 6202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23312;